import React from 'react';
import { Paper, Stack, Text, Button } from '@mantine/core';

interface UpgradeCardProps {
  upgradeTitle: string;
  upgradeDescription: string;
  onUpgrade: () => void;
  maxWidth?: number | string;
}

const UpgradeCard: React.FC<UpgradeCardProps> = ({
  upgradeTitle,
  upgradeDescription,
  onUpgrade,
  maxWidth = 360,
}) => (
  <Paper radius="md" shadow="md" p="md" style={{ minWidth: 320, maxWidth, border: 'none' }}>
    <Stack gap="sm">
      <Text fw={600} size="lg" mb={2}>
        {upgradeTitle}
      </Text>
      <Text size="sm" c="dimmed">
        {upgradeDescription}
      </Text>
      <Button
        size="md"
        color="var(--green-color)"
        fullWidth
        mt="md"
        onClick={onUpgrade}
        style={{ fontWeight: 600 }}
      >
        Upgrade now
      </Button>
    </Stack>
  </Paper>
);

export default UpgradeCard; 